const tiers = [
  { number: 1, notes: "Drops in / Upgrades from" },
  { number: 2, notes: "Drops in / Upgrades from" },
  { number: 3, notes: "Drops in / Upgrades from" },
  { number: 4, notes: "Drops in / Upgrades from" },
  { number: 5, notes: "Drops in / Upgrades from" },
  { number: 6, notes: "Drops in / Upgrades from" },
  { number: 7, notes: "Drops in / Upgrades from" },
  { number: 8, notes: "Drops in / Upgrades from" },
  { number: 9, notes: "Drops in / Upgrades from" },
  { number: 10, notes: "Drops in / Upgrades from" },
  { number: 11, notes: "Drops in / Upgrades from" },
  { number: 12, notes: "Drops in / Upgrades from" },
  { number: 13, notes: "Drops in / Upgrades from" },
  { number: 14, notes: "Drops in / Upgrades from" },
  { number: 15, notes: "Drops in / Upgrades from" },
  { number: 16, notes: "Drops in / Upgrades from" },
  { number: 17, notes: "Drops in / Upgrades from" },
];

export default tiers;
